// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageDE = {
  seo: {
    title: 'KI-Transparenz | pAIoneer Labs GmbH',
    description: 'Wie die pAIoneer Labs GmbH künstliche Intelligenz einsetzt und darüber informiert: KI-Assistent, Kennzeichnung KI-erzeugter Inhalte, redaktionelle Verantwortung und Ansprechpartner nach der KI-Verordnung.',
    keywords: 'KI-Transparenz, KI-Verordnung, AI Act, Art.\u00a050, Kennzeichnung, KI-Assistent, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'KI-Transparenz',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'KI-Transparenz',
    subtitle: 'Wie die pAIoneer Labs GmbH künstliche Intelligenz einsetzt und darüber informiert.'
  },
  sections: [
    {
      title: 'Rechtlicher Rahmen',
      paragraphs: [
        'Seit dem 2. August 2026 gelten die Transparenzpflichten nach Art.\u00a050 der Verordnung (EU) 2024/1689 über künstliche Intelligenz (KI-Verordnung). In Deutschland ist die Bundesnetzagentur nach dem KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG) Marktüberwachungsbehörde und Beschwerdestelle für die KI-Verordnung.',
        'Diese Seite beschreibt, welche KI-Systeme die pAIoneer Labs GmbH einsetzt und wie sie darüber informiert. Wie dabei personenbezogene Daten verarbeitet werden, beschreibt die Datenschutzerklärung.'
      ]
    },
    {
      title: 'KI-Assistent in unserer Anwendung',
      paragraphs: [
        'In unserer Anwendung beantwortet ein KI-Assistent Ihre Fragen. Er ist ein KI-System: Seine Antworten werden automatisch von Sprachmodellen erzeugt und können fehlerhaft sein. Prüfen Sie wichtige Angaben, bevor Sie Entscheidungen darauf stützen.',
        'Darauf weist die Anwendung vor Ihrer ersten Eingabe und dauerhaft neben dem Chat hin (Art.\u00a050 Abs.\u00a01 KI-Verordnung). Jede Antwort des Assistenten ist zusätzlich maschinenlesbar als KI-erzeugt gekennzeichnet (Art.\u00a050 Abs.\u00a02 KI-Verordnung).',
        'Die Sprachmodelle werden über den Dienst der OpenRouter, Inc., USA, bereitgestellt.'
      ]
    },
    {
      title: 'Direkte Kommunikation mit KI-Systemen',
      paragraphs: [
        'Kommuniziert ein KI-System der pAIoneer Labs GmbH unmittelbar mit Ihnen, etwa in einem Chat, gibt es sich spätestens bei der ersten Interaktion als KI-System zu erkennen.'
      ]
    },
    {
      title: 'Inhalte dieser Website',
      paragraphs: [
        'Die Texte dieser Website werden – auch wo KI-Werkzeuge bei ihrer Erstellung unterstützen – von der pAIoneer Labs GmbH geprüft und unter ihrer redaktionellen Verantwortung veröffentlicht (Art.\u00a050 Abs.\u00a04 Unterabs.\u00a02 KI-Verordnung).',
        'Bild-, Ton- oder Videoinhalte, die mit KI erzeugt oder verändert wurden und reale Personen, Orte oder Ereignisse täuschend echt darstellen, kennzeichnen wir als künstlich erzeugt oder verändert (Art.\u00a050 Abs.\u00a04 Unterabs.\u00a01 KI-Verordnung).'
      ]
    },
    {
      title: 'Analyse mit maschinellem Lernen',
      paragraphs: [
        'Mit Ihrer Einwilligung werten wir Besuchsstatistiken mit Methoden des maschinellen Lernens aus; Einzelheiten enthält die Datenschutzerklärung. Wir setzen dabei weder Emotionserkennung noch biometrische Kategorisierung ein (Art.\u00a050 Abs.\u00a03 KI-Verordnung). Die Unterscheidung zwischen Menschen und automatisierten Zugriffen beruht auf technischen Merkmalen von Gerät, Browser und Verbindung, nicht auf biometrischen Daten.'
      ]
    },
    {
      title: 'Beschwerde',
      paragraphs: [
        'Sie können sich mit einer Beschwerde über einen möglichen Verstoß gegen die KI-Verordnung an die Bundesnetzagentur wenden, die Marktüberwachungsbehörde und Beschwerdestelle für die KI-Verordnung in Deutschland. Informationen dazu stellt sie unter bundesnetzagentur.de/ki bereit.'
      ]
    }
  ],
  contact: {
    title: 'Kontakt',
    description: 'Für Fragen zum Einsatz künstlicher Intelligenz erreichen Sie uns per E-Mail.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Stand: 30. Oktober 2026'
};
